import sectionLabels from '../../constants/sectionLabels';

const buildNavGroup = (prevObj, current) => {
  const prev = prevObj;
  const { url, sec } = current;
  const sectionLabel = sectionLabels[sec] ? sectionLabels[sec].label : sectionLabels[sec];
  const placeholder = { label: sectionLabel, paths: [] };
  const currentIndex = prev.map(p => p.label).indexOf(sectionLabel);
  const currentGroup = prev[currentIndex] || placeholder;
  if (sec === '0') {
    return prev;
  }
  currentGroup.paths.push(url);
  if (currentIndex === -1) {
    prev.push(currentGroup);
  } else {
    prev[currentIndex] = currentGroup;
  }
  return prev;
};

export default buildNavGroup;
